var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"seg-tabs"},_vm._l((_vm.options),function(op){return _c('button',{key:op.value,staticClass:"seg-tab",class:{ active: op.value === _vm.value },attrs:{"type":"button"},on:{"click":function($event){return _vm.$emit('change', op.value)}}},[_vm._v(" "+_vm._s(op.name)+" ")])}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }